// Copyright © 2015 David Caldwell <david@porkrind.org>


var piles = require('./piles'), pile_game=piles.pile_game, pile=piles.pile, generic_foundation=piles.generic_foundation, in_suit_order=piles.in_suit_order,
    empty_pile_count=piles.empty_pile_count, up=piles.up, king=piles.king, ace=piles.ace, card=piles.card;
var piles_ui = require('./piles-ui'), grid = piles_ui.grid;
var seed_game = require('./seed_game'), WON=seed_game.WON;
var solitaire = require('./solitaire').games;
var lib = require('./lib'), filter=lib.filter;

solitaire.cruel = class extends pile_game {
    constructor() {
        super();
        this.pile_game_init(...arguments);
        this.foundation = [];
        this.tableau = [];
        for (let c=1; c<=4; c++)
            this.foundation.push(new generic_foundation("foundation"+c, this));
        for (let c=1; c<=12; c++)
            this.tableau.push(new this.tableau_pile("tableau"+c, this));
        this.redeal_button = new pile("redeal", this);
        this.redeal_button.icon = new card("redeal", void 0, 0, up, null, this);
        this.redeal_button.icon.ui.draw(this.redeal_button.ui, { x:0, y:0, z:-1 });
        this.redeal_button.accept = this.redeal_button.can_drag = function() { return false }; // Shouldn't this be the default?
        this.redeal_button.onclick = function() {
            this.push_state();
            this.moves.push("*"+this.redeal_button.move_char());
            this.redeal();
            this.redraw();
        }.bind(this);
    }

    tableau_pile = class extends pile {
        accept(card) { return this.pile.length > 0 && in_suit_order(card, this.top()) && 1; }
        can_drag(index) { return index == this.top_index(); }
        xoffset = .3/90;
        yoffset = .3/131;
        accept_stacks = false;
    }

    deal(deck) {
            let foundation = [];
            for (let f of this.foundation)
                foundation[f.icon.suit] = f;
            let aces = filter(function(c) { return c.rank == ace }, deck),
                rest = filter(function(c) { return c.rank != ace }, deck);
            for (let c; c=aces.pop();)
                foundation[c.suit].push(c.turn_face(up));
            this.redeal(rest);
    }

    redeal(deck) {
            if (!deck) {
                deck = [];
                for (let p of this.tableau)
                    while (p.pile.length)
                        deck.push(p.pile.shift());
            }
            let len = deck.length;
            for (let c=0; c<len; c++)
                this.tableau[Math.floor(c/4)].push(deck.shift().turn_face(up));
    }

    is_complete() {
            return this.foundation[0].pile.length == 13 && this.foundation[1].pile.length == 13 &&
                   this.foundation[2].pile.length == 13 && this.foundation[3].pile.length == 13 && WON;
    }

    score() {
            return this.count_cards_in(this.foundation) - 4;
    }

    complete() {
            return this.complete_generic(this.foundation, [this.tableau]);
    }

    layout = grid(["foundation1", "foundation2", "foundation3", "foundation4", undefined, "redeal"],
                  [ {x: +0, y: +.5},
                    "tableau1", "tableau2", "tableau3", "tableau4",  "tableau5",  "tableau6"],
                  ["tableau7", "tableau8", "tableau9", "tableau10", "tableau11", "tableau12"]);
}
// Copyright © 2015 David Caldwell <david@porkrind.org>


var piles = require('./piles'), pile_game=piles.pile_game, pile=piles.pile, generic_foundation=piles.generic_foundation, in_suit_order=piles.in_suit_order,
    empty_pile_count=piles.empty_pile_count, up=piles.up, king=piles.king, ace=piles.ace, card=piles.card;
var piles_ui = require('./piles-ui'), grid = piles_ui.grid;
var seed_game = require('./seed_game'), WON=seed_game.WON;
var solitaire = require('./solitaire').games;
var lib = require('./lib'), filter=lib.filter;

solitaire.cruel = class extends pile_game {
    constructor() {
        super();
        this.pile_game_init(...arguments);
        this.foundation = [];
        this.tableau = [];
        for (let c=1; c<=4; c++)
            this.foundation.push(new generic_foundation("foundation"+c, this));
        for (let c=1; c<=12; c++)
            this.tableau.push(new this.tableau_pile("tableau"+c, this));
        this.redeal_button = new pile("redeal", this);
        this.redeal_button.icon = new card("redeal", void 0, 0, up, null, this);
        this.redeal_button.icon.ui.draw(this.redeal_button.ui, { x:0, y:0, z:-1 });
        this.redeal_button.accept = this.redeal_button.can_drag = function() { return false }; // Shouldn't this be the default?
        this.redeal_button.onclick = function() {
            this.push_state();
            this.moves.push("*"+this.redeal_button.move_char());
            this.redeal();
            this.redraw();
        }.bind(this);
    }

    tableau_pile = class extends pile {
        accept(card) { return this.pile.length > 0 && in_suit_order(card, this.top()) && 1; }
        can_drag(index) { return index == this.top_index(); }
        xoffset = .3/90;
        yoffset = .3/131;
        accept_stacks = false;
    }

    deal(deck) {
            let foundation = [];
            for (let f of this.foundation)
                foundation[f.icon.suit] = f;
            let aces = filter(function(c) { return c.rank == ace }, deck),
                rest = filter(function(c) { return c.rank != ace }, deck);
            for (let c; c=aces.pop();)
                foundation[c.suit].push(c.turn_face(up));
            this.redeal(rest);
    }

    redeal(deck) {
            if (!deck) {
                deck = [];
                for (let p of this.tableau)
                    while (p.pile.length)
                        deck.push(p.pile.shift());
            }
            let len = deck.length;
            for (let c=0; c<len; c++)
                this.tableau[Math.floor(c/4)].push(deck.shift().turn_face(up));
    }

    is_complete() {
            return this.foundation[0].pile.length == 13 && this.foundation[1].pile.length == 13 &&
                   this.foundation[2].pile.length == 13 && this.foundation[3].pile.length == 13 && WON;
    }

    score() {
            return this.count_cards_in(this.foundation) - 4;
    }

    complete() {
            return this.complete_generic(this.foundation, [this.tableau]);
    }

    layout = grid(["foundation1", "foundation2", "foundation3", "foundation4", undefined, "redeal"],
                  [ {x: +0, y: +.5},
                    "tableau1", "tableau2", "tableau3", "tableau4",  "tableau5",  "tableau6"],
                  ["tableau7", "tableau8", "tableau9", "tableau10", "tableau11", "tableau12"]);
}
